import React from 'react';
import ReactDOM from 'react-dom/client';
import MyRoutes from './MyRoutes';
import Modal from 'react-modal';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles.css'


Modal.setAppElement('#root');


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <MyRoutes />
        <ToastContainer position='top-right' className="custom-toast-container" />
    </>
);

